/* @flow */

import { borderRadius } from 'src/shared/app/base/style/token/box';
import { phablet } from '@e180/ui/lib/token/mediaQuery';
import { mediumGrey } from '@e180/ui/lib/token/palette';

export default {
  root: {
    position: 'relative',
  },
  pictureUpload: {
    display: 'flex',
    justifyContent: 'center',

    paddingTop: 4,
  },
  screenshotButton: {
    marginBottom: 64,

    borderRadius: [borderRadius, 0, 0, borderRadius],
  },
  fileNameSection: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    width: 150,
    height: 42,
    padding: '0 12px',

    border: ({ accentColor }: Object) => `1px solid ${accentColor}`,
    color: mediumGrey,

    [phablet]: {
      width: 250,
    },
  },
  fileName: {
    display: 'flex',
    overflow: 'hidden',

    maxWidth: '100%',

    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  clearBtn: {
    paddingLeft: 12,
  },
  close: {
    fill: ({ accentColor }: Object) => accentColor,
  },
  screenshotInput: {
    display: 'none',
  },
  imageError: {
    position: 'absolute',
    top: 56,
    left: '0',
    right: '0',

    textAlign: 'center',
  },
};
